/**
* Do not edit directly
* Generated on Fri, 10 Mar 2023 21:41:50 GMT
*/

module.exports = {
  "colors": {
    "link": {
      "color": "#52a2f4",
      "hover": {
        "color": "#77bbff"
      }
    },
    "text": {
      "heading": "#ececec",
      "body": "#b5b6b6",
      "brand": "#fd6d9d"
    },
    "input": {
      "background": "#1d1d1d",
      "border": "#798599",
      "placeholder": "#444d59",
      "text": "#e8edf4",
      "hover": {
        "border": "#8290a4"
      }
    },
    "btn-primary": {
      "50": "#032a4d",
      "100": "#043159",
      "200": "#073b68",
      "300": "#0e4e86",
      "400": "#1e6ab0",
      "500": "#3488d8",
      "600": "#3e92e4",
      "700": "#52a2f4",
      "800": "#77bbff",
      "900": "#b1daff",
      "fontColor": "#fff"
    },
    "btn-secondary": {
      "50": "#222222",
      "100": "#282929",
      "200": "#282929",
      "300": "#282929",
      "400": "#282929",
      "500": "#282929",
      "600": "#303030",
      "700": "#393939",
      "800": "#4b4c4c",
      "900": "#676868",
      "fontColor": "#52a2f4"
    },
    "btn-brand": {
      "50": "#580026",
      "100": "#65002d",
      "200": "#760036",
      "300": "#990049",
      "400": "#c91367",
      "500": "#eb4384",
      "600": "#f3548e",
      "700": "#fd6d9d",
      "800": "#ff97b8",
      "900": "#ffc6d7",
      "fontColor": "#fff"
    },
    "btn-danger": {
      "50": "#5a0000",
      "100": "#6a0000",
      "200": "#7a0000",
      "300": "#9e0007",
      "400": "#c92425",
      "500": "#e5534b",
      "600": "#ec6259",
      "700": "#f5796e",
      "800": "#fd9c92",
      "900": "#ffc8c1",
      "fontColor": "#fff"
    }
  },
  "radii": {
    "0": "0",
    "input": {
      "xs": "0.25rem",
      "sm": "0.375rem",
      "md": "0.375rem",
      "lg": "0.375rem"
    },
    "none": "0",
    "2xs": "0.0625rem",
    "xs": "0.125rem",
    "sm": "0.25rem",
    "md": "0.375rem",
    "lg": "0.5rem",
    "xl": "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    "full": "624.9375rem"
  },
  "semanticTokens": {
    "colors": {
      "background": "radial-gradient(78.02% 20% at 50% 0%, #1c141f 0%, #0c0d0e 100%)",
      "warning": "#c96c25",
      "success": "#92e998",
      "danger": "#ec6259"
    }
  },
  "breakpoints": {
    "base": "0",
    "sm": "26.25rem",
    "md": "40rem",
    "lg": "53.75rem",
    "xl": "67.5rem",
    "2xl": "81.25rem"
  },
  "space": {
    "spacing-0": "0",
    "spacing-25": "0.0625rem",
    "spacing-50": "0.125rem",
    "spacing-100": "0.25rem",
    "spacing-200": "0.5rem",
    "spacing-400": "1rem",
    "spacing-600": "1.5rem",
    "spacing-800": "2rem",
    "spacing-1200": "3rem",
    "spacing-1800": "4.5rem",
    "spacing-2400": "6rem",
    "spacing-3000": "7.5rem",
    "spacing-3600": "9rem",
    "spacing-4200": "10.5rem"
  },
  "fonts": {
    "heading": "Open Sans, Geneva, Verdana, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "body": "Open Sans, Geneva, Verdana, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "mono": "Operator Mono, Fira Code Retina, Bitstream Vera Sans Mono, ui-monospace, Menlo, Monaco, Cascadia Mono, Segoe UI Mono, Roboto Mono, Oxygen Mono, Ubuntu Monospace,Source Code Pro, Fira Mono, Droid Sans Mono, Courier New, monospace"
  },
  "fontSizes": {
    "3xs": "0.625rem",
    "2xs": "0.78125rem",
    "xs": "0.875rem",
    "sm": "0.9375rem",
    "md": "1.0625rem",
    "lg": "1.3125rem",
    "xl": "1.75rem",
    "2xl": "2.125rem",
    "3xl": "2.9375rem",
    "4xl": "3.625rem",
    "5xl": "4.9375rem",
    "6xl": "6rem"
  },
  "lineHeights": {
    "3xs": "160%",
    "2xs": "160%",
    "xs": "142.9%",
    "sm": "160%",
    "md": "141.2%",
    "lg": "152.4%",
    "xl": "142.9%",
    "2xl": "129.4%",
    "3xl": "102.1%",
    "4xl": "117.2%",
    "5xl": "121.5%",
    "6xl": "125%"
  },
  "letterSpacings": {
    "3xs": "0.012em",
    "2xs": "0em",
    "xs": "-0.0014000000000000002em",
    "sm": "-0.002em",
    "md": "-0.0026em",
    "lg": "-0.01em",
    "xl": "-0.012em",
    "2xl": "-0.015em",
    "3xl": "-0.017em",
    "4xl": "-0.015em",
    "5xl": "-0.006999999999999999em",
    "6xl": "-0.013000000000000001em",
    "allCaps": "0.1em"
  },
  "fontWeights": {
    "light": 300,
    "regular": 400,
    "semibold": 600,
    "bold": 700
  }
}